import React from 'react';
import { Provider } from 'react-redux';
import { merge } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25 } from '@sm360/widget-commons-vehicle';
import { ReduxClient } from '@sm360/widget-commons-general';
import { loadPurchaseMethodsSuccess } from 'payment-calculator-v25/actions/paymentCalculatorActions.js';
// import configureStore from 'payment-calculator-v25/store/configureStore.js';
import PaymentCalculator from 'payment-calculator-v25/components/PaymentCalculator/PaymentCalculator.jsx';
import en from 'payment-calculator-v25/i18n/en.json';
import fr from 'payment-calculator-v25/i18n/fr.json';

const { PurchaseMethodsModelV25 } = PurchaseMethodsV25;

// const store = configureStore();

// eslint-disable-next-line react/display-name
class PaymentCalculatorProvider extends React.Component {
    constructor(props) {
        super(props);

        this.storeRedux = ReduxClient.getOrCreate();

        this.storeRedux.dispatch(
            loadPurchaseMethodsSuccess(
                new PurchaseMethodsModelV25({
                    transactionToken:
                        'gAwAAAAAAAAAAAAAAAAAAAASwgfAsqpMcdkHMOTAKmaCfN9LcSHM1HClvJI4PiFFCH4qqiDMoelShkoqTNqBS-n7cWL51xEetWi6MRn126JT1X6YpgeWHOXobjfDE6czpLHZgiRDG0Hg3rAFrlIZmXvzTTgjWDVxv0J_dQhzB2vZDKvZrAqQ7-K7DMl9tp0zGpFQF-Gaf11Wk3Eb9jEb7RwUbYaMKaLycNwhi6Ymq3fkSW1eSgoKcU_B-sl2-vATesr31GJnTCMyAhpZa4GC5ShwW2yLcz50_VyCY2DoV9BV9FGyGkV4tj8fYUd2-LlyiXWh7y13gr1OYc5553Wycq0n9X9zslotYQ-aIpFk1ZkOB0Qbx6RWL81zqdNlo1twQ8dOtjQHyim-Z-5UOVb5rX9hYUUHwAyb9RS96DkfaWukbpaYZ70VSq60Qf42WJte0jKoEiRfulX6EYlC-Pz09QyZ6TsZ-EPFfxeWmC2yQMOpLo5jfPe9Mum1nIOSkCSYIGisPxHV6yM2umQfoTQDgvbBDp8qmhr2mc6LyvE0w9OzEnDAWmsBgDo2xkb6E2Q8UXDLG_oCHPqBJgTflrfs8r1cJ0wZ7DxrADWy9Rdh7oAqyShjnVadBXcVnB835_oF-YxMJQZLKqvYVVF_j2MXE69DcRLEvxpDkKB5yJiwZTSboCpRzbeb3j58V4mKPZndvctRqVWBBEuWg-D_LVQTGiFfM761dTzWdfvReFDKGWf10kgQG2mBO94ZvR-0Ak8gHSu_1hKb72gSy2vrtPyupOnghYU6qoHVm9FNlbqP9p8t9o_ri0taR4KIUrRnr7-Fks3F1y8x_epddssK26HoT0vJWGG_at1ntDyge48TF7YXiRTxv5YwnbEC5F-dTjY3Dq6EiSp8dKpr44RpYeVaErr5fn-4jWzAE-q5dnHoMBQcxC_9K5KgCH-2Pje1WCSAAtV2zreuBVoHWX4EngGRR8vPK-jLZT8L5oRpmxwNqL-r2hDjj-6ypbqRg2NkZQ_FVmcxwgYPKLVT_4EeVkmTArl8JTV87e9ZTI3Y-MyExq-mJmPOueoaEZ5snLOUAP0YyuOR5GWYD6MxCNHTQR0LRMPLjgC7qLgf3ren9xFygH_XzXgkZsGzhQMIhMT_0ZqIvllWmka-KFWhYV-BmxdPwZWRoH-rP1dJAK9of2tUZb3N-8GOB6yaEczSqDB2j88bau5aSXcygFv9wUS_xUrhiIIFQ1RiZ0CINUYQ8eHXa-wQ0XbGV61EiLA4QRuR6WSZXRyi88MW5ktxqpPrj3WNoVWJfmXl42wFUCUUnMKfu4x0oHYlghZbmvNoVoYaGEYu1fwwY6vl_Y_ghi9P_yv_1Am7PBL0Ba1TRZB3N_c9waM6ACQhLYcRTuyrqY6os8WBggfQ9MOAQe9JIQLpOBbeqiqNlTrz-MMbKcaW63-o9hX0HxKefLQCgeJ6CM_khAa_0jgCJvy-ETeYtwdBoyAlzgl46xc3mbtRcJxXswSfVksD3af8ImbwvEzO4swZrPc-p2bMK3K-nF7oC4w-na61zyQEfEVNoOaT3sbYb375sLnjwM6upN5kqpX7xAfedpF94Oko71rTBt31YlDtXboE3aNdBUydjqkbRQUTEfJsDXdiPcLMlN8keayxvUw_9fN0RQlxMECQ2_ctHW-K2oVW49XUK1XfUuXSMh3lzztpP3FD47GackHCffKmQ6HaA0Ia6CZOgdKjW_QvGFxxW3abzjOroHN9vDQzFIQUclMXYyaP57RCH33htEL8gWAnzbFPGMPJS8ezcswfJ2vDayucLwjS_Yueb0Bzui-uRZpg6o4tZG7Ou7nz8p3IY6S7kxGi8IG6v5tp6t7rW7mC-05n0FAlE7arHR7uduAafiuCB4NPMwHYYVEKMecs3CfDNOeHl2qeT4mEHjGMCplrjGkvUuVq9L_jYHuXYlW-ZKCWJu5A0ZG7rQ9-zyl7RxktdRm_MueZlKCzKEs1aTZMP61rxeVsMqhYy51fFvsVM_JrN8mnrcIGcQFwSG5Z7Vphl9sTXoaXrG-C0orR_P1VNtjG2LEfGxqETBtGiVI5nON3dSEPKtEwmY1hoXFNDuxdyNz1AQn1Gv5_R4N-vJq7Sn55xtv06oJD1F0XpD1U60SXGJa6rfcYgwqSC79yaWauooZ2wpTKbH04LBqCu2qSU7kVB0ehE3sd-rYsdSw4aiKyZc3O4xwPYHmAbyhfe8G3JOVaem8-ckFXerfqRSbT0ognnK8w4sRTclg1p7izEEKMvgGlGXH9SnWhsKdDOZwnFheawj1JtBAhshzs2ZSDGhQq4JLrKIq3MSbJ7O14xKc3Agh7-JlQPYzMpwT3w6JYwCDjnr8F4v3ut1rJB3NuW2-izB-y12MmNLhH4whBMbTwDgG_LvocBZGWZeN2EuZyV2sioXug6cpQa2Ke_BudQPfin_VUL7c5URoLDmvn-kQUCn_xtMkSycMdWBfKIUPwxdrbQqv13ImeWqs5e59dLirUayae6bQLGWQZGQzhcnA6YwBeX1n119V7t8-S7kjGIR1TRla3tItXmOzQIZ6qoIC9foYxdseC411mUqJLAzRZjz9yqMRFbqzVX-0pXf-_Qjh4OGBt_8z6spcgsRd4CX23SOGDIedi8LmfK_zxq87yGtcFrkhtxBz3EM_s1raWrMegzKsdfMZUpwiGwUR1LQh3gSg3WwCGO7DEW012gRv8Jl1oYLmGRuFJDdXlFw',
                    saleType: 'retail',
                    taxPlan: 'standard',
                    vehicleCondition: 'used',
                    odometer: 0,
                    tradeIn: 0,
                    lien: 0,
                    showNegativeEquityOffset: false,
                    negativeEquityOffsetType: 'ignore',
                    positiveEquityOffsetType: 'ignore',
                    showPositiveEquityOffset: false,
                    purchaseMethod: 'finance',
                    financePlan: '6da39441-569d-86cd-a7bb-f33982df82e7.5',
                    kmPerYearPlan: 0,
                    paymentFrequency: 52,
                    cashDown: 0,
                    term: 72,
                    disclaimer:
                        'Finance selling price is $22,856.25 (plus taxes).  Finance payments includes: Registration fee ($76.25), OMVIC Fee ($10.00).  Finance offer is based on a 72 months term and 6.97% interest rate.  312 weekly payments of $89.69 ($101.31 taxes included) with $0.00 cash down and $0.00 net trade in. Cash down payments are due upon vehicle delivery.  Finance total obligation is $31,608.72 (taxes included).  Finance total cost of credit is $5,791.07.  Limited time purchase financing offer on approved credit. Some customers will not qualify. Rates and requirements may vary depending on credit worthiness. Payments and conditions may vary for a commercial use.   All applicable taxes are calculated on the total amount prior to deduction of the down payment.',
                    cashPurchase: {
                        sellingPrice: 42689,
                        tradeIn: 0,
                        lien: 10,
                        totalToPay: 48237.27,
                        salesDeposit: 0,
                        totalBalanceDue: 48237.27,
                        retailDetails: {
                            msrp: 39850,
                            freightAndPDI: 2700,
                            taxesAndDuties: 130,
                            otherFeesAndItems: 10,
                            total: 42690,
                        },
                        incentives: {
                            manufacturerRebates: 0,
                            manufacturerRebatesWithoutTaxes: 0,
                            governmentRebates: 0,
                            governmentRebatesWithoutTaxes: 0,
                            dealerRebates: 1,
                            dealerRebatesWithoutTaxes: 1,
                            total: 1,
                            totalWithoutTaxes: 1,
                            deliveryBonus: 0,
                            electricRebateIncluded: false,
                            effectiveIncentiveProgram: {
                                id: '2399ee26f944cc6f74f9ab6b48c5a9219790cef4',
                                incentiveRevision: '4419934469244784070',
                                incentiveEffectiveDate: 1641483718,
                                description: 'Incitatif 2022-01-06',
                                isCurrent: true,
                            },
                        },
                        feesDisclaimer:
                            "Le prix de vente (42 689,00 $) à l'achat au comptant inclus: Transport et Préparation (2 700,00 $), Taxe d'accise sur le climatiseur (100,00 $), Taxe de recyclage des pneus (20,00 $), Équité négative (10,00 $), Frais OMVIC (10,00 $). (TVH) sont en supplément.",
                        taxesDisclaimer: '(TVH), immatriculation, assurances & enregistrement non inclus.',
                        tradeInTaxCreditsDetails: {
                            tradeIn: 0,
                            tradeInTaxCredits: 0,
                            taxesDetail: 'TVH',
                            totalTradeIn: 0,
                        },
                        salesNumbers: '4_V_271/0_O_84/0_A_0/0_T_0/4_TT_355',
                        taxesValidationAmount: {
                            category: 'redBook',
                            amount: 0,
                        },
                    },
                    finance: {
                        kmPerYearPlan: 0,
                        paymentFrequency: 52,
                        tradeIn: 0,
                        lien: 0,
                        salesDeposit: 0,
                        cashDown: 100,
                        term: {
                            term: 72,
                            apr: 6.97,
                            aprDetails: {
                                initialApr: 6.97,
                                adjustment: 0,
                                totalApr: 6.97,
                                totalInterestToPay: 5791.07,
                                totalObligation: 31608.72,
                                totalCreditCost: 5791.07,
                                creditRate: 7.08,
                                creditRateDisclaimer: 'The effective interest rate is 7.08%.',
                                baseCreditRate: 6.97,
                                baseCreditCost: 0,
                                cashOnlyRebates: 0,
                                adminFeesNotChargedToCash: 0,
                                cashOnlyRebatesAdjustment: 0,
                                adminFeesNotChargedToCashAdjustment: 0,
                            },
                            numberOfPayments: 312,
                            payment: 89.69,
                            paymentTaxes: 11.62,
                            taxesDetail: 'HST',
                            totalPayment: 101.31,
                            amountFinanced: 25817.65,
                            dueAtDelivery: 0,
                            residualDetails: {
                                initialResidualRetail: 0,
                                residualRetailAdjustment: 0,
                                totalResidualRetail: 0,
                                initialResidualRate: 0,
                                residualRateAdjustment: 0,
                                totalResidualRate: 0,
                                calculatedResidualAmount: 0,
                                residualAmountAdjustment: 0,
                                totalResidualAmount: 0,
                                buyBackFee: 0,
                                buyBackAmount: 0,
                                accessoriesResidualRetail: 0,
                                baseResidualRetail: 0,
                            },
                            securityDepositDetails: {
                                securityDepositIsWaived: false,
                                securityDepositAmount: 0,
                                msdCount: 0,
                                msdAmount: 0,
                            },
                            kmPerYearPlanDetails: null,
                            paymentTaxesDetails: null,
                        },
                        sellingPrice: 22780,
                        incentives: {
                            manufacturerRebates: 0,
                            manufacturerRebatesWithoutTaxes: 0,
                            governmentRebates: 0,
                            governmentRebatesWithoutTaxes: 0,
                            dealerRebates: 1030,
                            dealerRebatesWithoutTaxes: 0,
                            total: 1030,
                            totalWithoutTaxes: 0,
                            deliveryBonus: 0,
                            electricRebateIncluded: false,
                            effectiveIncentiveProgram: {
                                id: '',
                                incentiveRevision: '',
                                incentiveEffectiveDate: 0,
                                description: '',
                                isCurrent: true,
                            },
                        },
                        feesDisclaimer:
                            'Finance selling price ($22,856.25) includes: Registration fee ($76.25), OMVIC Fee ($10.00). (HST) are extra.',
                        taxesDisclaimer: '(HST), licence & registration not included.',
                        tradeInTaxCreditsDetails: {
                            tradeIn: 0,
                            tradeInTaxCredits: 0,
                            taxesDetail: 'HST',
                            totalTradeIn: 0,
                        },
                        cashDownTaxesDetails: {
                            cashDown: 0,
                            cashDownTaxes: 0,
                            taxesDetail: 'HST',
                            totalCashDown: 0,
                            cashDownIncludesTaxes: false,
                            rebatesIncludesTaxes: false,
                        },
                        salesNumbers: '9_V_240/0_O_0/0_A_0/0_T_0/9_TT_240',
                        taxesValidationAmount: {
                            category: 'redBook',
                            amount: 0,
                        },
                    },
                    cashPurchaseOption: {
                        transaction: [
                            {
                                category: 'base',
                                name: 'Prix de base',
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'PDSF',
                                        photo: '',
                                        amount: 38650,
                                    },
                                    {
                                        description: 'Transport et Préparation',
                                        photo: '',
                                        amount: 2700,
                                    },
                                    {
                                        description: 'Taxes et droits',
                                        photo: '',
                                        amount: 130,
                                    },
                                    {
                                        description: 'Autres frais',
                                        photo: '',
                                        amount: 0,
                                    },
                                ],
                                amount: 41480,
                                disclaimer: '',
                            },
                            {
                                category: 'discount',
                                name: 'Escomptes',
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'Rebate',
                                        photo: '',
                                        amount: -1,
                                    },
                                ],
                                amount: -1,
                                disclaimer: '',
                            },
                            {
                                category: 'option',
                                name: 'Accessoires & Options',
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'Ensemble Canada Edition',
                                        photo: '',
                                        amount: 1200,
                                    },
                                    {
                                        description: 'Équité négative',
                                        photo: '',
                                        amount: 10,
                                    },
                                ],
                                amount: 1210,
                                disclaimer: '',
                            },
                            {
                                category: 'protection',
                                name: 'Protections',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'total',
                                name: 'Prix de vente',
                                isTotal: true,
                                isExpandable: false,
                                items: [],
                                amount: 42689,
                                disclaimer: '',
                            },
                            {
                                category: 'tradeIn',
                                name: "Allocation d'échange",
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'Équité négative (contre partie)',
                                        photo: '',
                                        amount: -10,
                                    },
                                ],
                                amount: -10,
                                disclaimer: '',
                            },
                            {
                                category: 'tax',
                                name: 'Taxes',
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'TVH (13,000%)',
                                        photo: '',
                                        amount: 5548.27,
                                    },
                                ],
                                amount: 5548.27,
                                disclaimer: '',
                            },
                            {
                                category: 'lien',
                                name: "Dû sur l'échange",
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: '',
                                        photo: '',
                                        amount: 10,
                                    },
                                ],
                                amount: 10,
                                disclaimer: '',
                            },
                            {
                                category: 'protectionsIncluded',
                                name: 'Protections (taxes incl)',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'otherFeeTaxesIncluded',
                                name: 'Autres frais (taxes incl)',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'rebate',
                                name: 'Rabais',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'cashDown',
                                name: 'Acompte',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'toPay',
                                name: 'Total à payer',
                                isTotal: true,
                                isExpandable: false,
                                items: [],
                                amount: 48237.27,
                                disclaimer: '',
                            },
                            {
                                category: 'base',
                                name: 'Montants exclus',
                                isTotal: false,
                                isExpandable: true,
                                items: [
                                    {
                                        description: 'Accessoires & Options',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Transport et Préparation',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Taxes et droits',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Autres frais',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Protections',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Garanties',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Garanties (taxes incl.)',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Protections (taxes incl)',
                                        photo: '',
                                        amount: 0,
                                    },
                                    {
                                        description: 'Autres frais (taxes incl)',
                                        photo: '',
                                        amount: 0,
                                    },
                                ],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'tax',
                                name: 'Taxes',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'rebate',
                                name: 'Rabais',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'cashDown',
                                name: 'Acompte',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'deposit',
                                name: 'Dépôt',
                                isTotal: false,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                            {
                                category: 'total',
                                name: 'Dû à la livraison',
                                isTotal: true,
                                isExpandable: false,
                                items: [],
                                amount: 0,
                                disclaimer: '',
                            },
                        ],
                        incentives: {
                            manufacturerRebates: 0,
                            manufacturerRebatesWithoutTaxes: 0,
                            governmentRebates: 0,
                            governmentRebatesWithoutTaxes: 0,
                            dealerRebates: 1,
                            dealerRebatesWithoutTaxes: 1,
                            total: 1,
                            totalWithoutTaxes: 1,
                            deliveryBonus: 0,
                            electricRebateIncluded: false,
                            effectiveIncentiveProgram: {
                                id: '',
                                incentiveRevision: '',
                                incentiveEffectiveDate: 0,
                                description: '',
                                isCurrent: false,
                            },
                        },
                        baseSellingPrice: 42549,
                        disclaimer: '',
                    },
                    financeOptions: [
                        {
                            isAvailable: false,
                            isSelected: false,
                            purchaseMethod: 'lease',
                            financePlan: '',
                            financePlanDescription: '',
                            kmPerYearPlan: 0,
                            paymentFrequency: 52,
                            selectedTerm: 0,
                            selectedCashDown: 0,
                            selectedTotalCashDown: 0,
                            selectedApr: 0,
                            selectedPayment: {
                                payment: 0,
                                paymentTaxes: 0,
                                taxesDetail: '',
                                totalPayment: 0,
                                validPaymentRange: [],
                                validTotalPaymentRange: [],
                            },
                            cashDownOptions: [],
                            sellingPrice: 0,
                            baseSellingPrice: 0,
                            amountFinanced: 0,
                            dueAtDelivery: 0,
                            incentives: {
                                manufacturerRebates: 0,
                                manufacturerRebatesWithoutTaxes: 0,
                                governmentRebates: 0,
                                governmentRebatesWithoutTaxes: 0,
                                dealerRebates: 0,
                                dealerRebatesWithoutTaxes: 0,
                                total: 0,
                                totalWithoutTaxes: 0,
                                deliveryBonus: 0,
                                electricRebateIncluded: false,
                                effectiveIncentiveProgram: {
                                    id: '',
                                    incentiveRevision: '',
                                    incentiveEffectiveDate: 0,
                                    description: '',
                                    isCurrent: false,
                                },
                            },
                            residualDetails: {
                                totalResidualRetail: 0,
                                totalResidualRate: 0,
                                totalResidualAmount: 0,
                            },
                            buyBackAmount: 0,
                            disclaimer: '',
                        },
                        {
                            isAvailable: true,
                            isSelected: true,
                            purchaseMethod: 'finance',
                            financePlan: '6da39441-569d-86cd-a7bb-f33982df82e7.5',
                            financePlanDescription: 'CIBC Finance (2016 & Up)',
                            kmPerYearPlan: 0,
                            paymentFrequency: 52,
                            selectedTerm: 72,
                            selectedCashDown: 0,
                            selectedTotalCashDown: 0,
                            selectedApr: 6.97,
                            selectedPayment: {
                                payment: 89.69,
                                paymentTaxes: 11.62,
                                taxesDetail: 'HST',
                                totalPayment: 101.31,
                                validPaymentRange: [0, 89.69],
                                validTotalPaymentRange: [11.62, 101.31],
                            },
                            cashDownOptions: [
                                {
                                    cashDown: 0,
                                    totalCashDown: 0,
                                    terms: [
                                        {
                                            term: 72,
                                            apr: 6.97,
                                            payment: 89.69,
                                            totalPayment: 101.31,
                                        },
                                        {
                                            term: 60,
                                            apr: 6.97,
                                            payment: 104.14,
                                            totalPayment: 117.63,
                                        },
                                        {
                                            term: 48,
                                            apr: 6.97,
                                            payment: 125.9,
                                            totalPayment: 142.22,
                                        },
                                        {
                                            term: 36,
                                            apr: 6.97,
                                            payment: 162.29,
                                            totalPayment: 183.34,
                                        },
                                        {
                                            term: 24,
                                            apr: 6.97,
                                            payment: 235.26,
                                            totalPayment: 265.79,
                                        },
                                        {
                                            term: 12,
                                            apr: 6.97,
                                            payment: 454.54,
                                            totalPayment: 513.53,
                                        },
                                    ],
                                },
                                {
                                    cashDown: 2000,
                                    totalCashDown: 2000,
                                    terms: [
                                        {
                                            term: 72,
                                            apr: 6.97,
                                            payment: 81.84,
                                            totalPayment: 93.46,
                                        },
                                        {
                                            term: 60,
                                            apr: 6.97,
                                            payment: 95.02,
                                            totalPayment: 108.52,
                                        },
                                        {
                                            term: 48,
                                            apr: 6.97,
                                            payment: 114.88,
                                            totalPayment: 131.2,
                                        },
                                        {
                                            term: 36,
                                            apr: 6.97,
                                            payment: 148.08,
                                            totalPayment: 169.13,
                                        },
                                        {
                                            term: 24,
                                            apr: 6.97,
                                            payment: 214.65,
                                            totalPayment: 245.17,
                                        },
                                        {
                                            term: 12,
                                            apr: 6.97,
                                            payment: 414.69,
                                            totalPayment: 473.69,
                                        },
                                    ],
                                },
                            ],
                            sellingPrice: 22780,
                            baseSellingPrice: 22770,
                            amountFinanced: 25817.65,
                            dueAtDelivery: 0,
                            incentives: {
                                manufacturerRebates: 0,
                                manufacturerRebatesWithoutTaxes: 0,
                                governmentRebates: 0,
                                governmentRebatesWithoutTaxes: 0,
                                dealerRebates: 1030,
                                dealerRebatesWithoutTaxes: 0,
                                total: 1030,
                                totalWithoutTaxes: 0,
                                deliveryBonus: 0,
                                electricRebateIncluded: false,
                                effectiveIncentiveProgram: {
                                    id: '',
                                    incentiveRevision: '',
                                    incentiveEffectiveDate: 0,
                                    description: '',
                                    isCurrent: false,
                                },
                            },
                            residualDetails: {
                                totalResidualRetail: 0,
                                totalResidualRate: 0,
                                totalResidualAmount: 0,
                            },
                            buyBackAmount: 0,
                            disclaimer: '',
                        },
                    ],
                })
            )
        );

        merge(en, PurchaseMethodsV25.Translations.en);
        merge(fr, PurchaseMethodsV25.Translations.fr);

        LocaleService.setLocale('fr');
        LocaleService.loadTranslations({ en, fr });
    }

    render() {
        return (
            <Provider store={this.storeRedux}>
                <PaymentCalculator {...this.props} />
            </Provider>
        );
    }
}

export default PaymentCalculatorProvider;
